import { render, staticRenderFns } from "./SFilePicker.vue?vue&type=template&id=b7edaf36&scoped=true&"
import script from "./SFilePicker.vue?vue&type=script&lang=js&"
export * from "./SFilePicker.vue?vue&type=script&lang=js&"
import style0 from "./SFilePicker.vue?vue&type=style&index=0&id=b7edaf36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7edaf36",
  null
  
)

export default component.exports